import React, { Fragment } from 'react';
import { connect } from 'react-redux';
// import format      from 'date-fns/format';
// import isEqual     from 'date-fns/isEqual';
// import PicGetRequest  from '../apis/PicGetRequest';
import { ExpansionPanel } from './ExpansionPanel';
import { PicInvitationHelpTable } from './PicInvitationHelpTable';
import { DropDownMenu } from './menus/DropDownMenu';
import { TextButton } from './buttons/TextButton';
import   MessageModal  from './modals/MessageModal';
import { prtStart, prtVar, prtMsg } from '../utils/prt';


const FNAME = "PicInvitationHelpPanel";
const TRACE = true;

// ***************************************************************************
// Component process
// When component mounts the following occurs:
//   - Make api call to get contributions for event and save in local state
//   - Call function to convert contributions array of objects to an array of an array
//   - This conversion function also copies the quantity needed from cell 1 to cell 4 
//     Cell 1 is used as the original amount needed and Cell 4 keeps track of user input
// In the render():
//   - The Styled Table is displayed dynamically by using contributions saved in local
//     state and getStyledContribTable() function.
// Everytime user changes quantity value the onChange method will: 
//   - update the value in cell 4 of the contributions list in local state.
//   - the render function will re-render table with new value.
// ***************************************************************************

const TopBorder = () => (
    <div className="pic-event-tb"/> 
);

// This a flex table component that takes as props an array of rows (each row has array of column/cells) that 
// allows for a fixed number of columns (eg 3 or 4). Note that the contents of each cell or column in the 
// flex table can be text or jsx. The mapping of the data to the JSX structures is done in the componentDidMount
// lifecycle method.
export class PicInvitationHelpPanel extends React.Component { 

    constructor(props) {
        super(props);

        this.state = {
            eventObj: this.props.dataset1 || {},
            headerLabels: ["Help Needed", "People Needed", "", "names"],
            showMessageModal: false,
            formError: ''
        }
    }

    //*************************************************************************
    // Lifecycle methods
    //*************************************************************************

    /* Initialize event info object and contribution list. It does not change so its ok to save in this
       child component  */
    componentDidMount = () => {
        let eventObj        = this.props.dataset1 || {};
        this.setState({eventObj});
    }

    
    //*************************************************************************
    // Event Handlers
    //*************************************************************************
    /* this handler is used by ErrorMessage Component. When user clicks the X
     it clears the formError value and effectively closes the message box */
    clearErrorMessage = () => {
        this.setState({formError: ''})
    }

    /* This is fired when user clicks caret icon on the expansion panel */
    handleOnClickForPanel2 = () => {
        this.props.handleOnClickForPanel();
    } 

    /* This is fired when user clicks the "Count Me In" button. After validating input, this
       handler will update the contributors list with the participants contribution. Note that 
       the participant is referred to as the contributor in this handler. Also note that the 
       item is marked as updated. This is for purposes of only sending updated items 
       to the API, as opposed to sending entire list   */
    handleCountMeInButton = (indexValue) => {
        //TRACE && prtStart(FNAME, "handleCountMeInButton");
        //TRACE && prtInput("indexValue", indexValue);

        // if (this.props.mockMode) {return;}

        // /* First and foremost get username and  user-email to be able to track who is participating */
        // /* If user is logged in, use the name of the authorized user */
        // let helpingHandsList = this.props.dataset2;

        // //TRACE && prtMsg("Following input comes from 'this.props.dataset2'")
        // //TRACE && prtInput("helpingHandsList ", helpingHandsList)

        // let participantName  = this.getParticipantName();
        // let participantEmail = this.getParticipantEmail();

        // if (participantEmail === "none") {
        //     //TRACE && prtVar("participantEmail", participantEmail); 
        //     this.setState({showMessageModal: true})
        //     return;
        // }

        // /* Set quantity needed and set contribution */
        // let peopleNeeded = helpingHandsList[indexValue][1];
        
        // let helpingHandsListCopy = [...helpingHandsList];
        
        // /* decrement number of people need by 1. If 0 , do nothing  */
        // peopleNeeded = peopleNeeded === 0 ? 0 : peopleNeeded - 1;
        // helpingHandsListCopy[indexValue][1]  = peopleNeeded;


        // /* mark item as updated */
        // helpingHandsListCopy[indexValue][4]  = "updated";

        // /* construct help participant object */     
        // let participant = {
        //     email: participantEmail,
        //     name:  participantName
        // }

        // /* if participant not on list, add in front the participants array */
        // if (!this.isParticipantOnList(indexValue)) {
        //     let participantList  = this.getParticipantList(helpingHandsListCopy, indexValue);
        //     participantList.unshift(participant);
        //     helpingHandsListCopy[indexValue][3] = participantList;  /* 3 is column for array */
        // }

        // /* update list on database */            
        // this.props.handleChangeDataSet2(helpingHandsListCopy);

        /* Call Parent's Count Me in Button handler */            
        this.props.handleHelpingHandsCountMeInButton(indexValue);
    // }
    }
    
    /* Calls the parent handler used to raise an error */
    handleRaiseError = (text) => {
        this.props.raiseErrorHandler(text);
    }

    /* Handler for MessageModal    */
    handleCancelMessageModal = () => {
        //TRACE && prtStart(FNAME, "handleCancelMessageModal");
        //TRACE && prtMsg("Setting state value showMessageModal to false");
        this.setState({showMessageModal: false})
    }

    //*************************************************************************
    // Column Header Renderer
    //*************************************************************************

    /* Based on column header, send different classname  */
    getHeaderJsx= (content, classname) => {
        return (
            <div className={`${classname}`}>
                {content}
            </div>
        )
    }

    //*************************************************************************
    // Column Renderers 
    //*************************************************************************

    getTextColumnJsx = (content, justify) => {
        // console.log("=========> TEXT COLUMN " ,content);
        return (
            <div className={`piht-text-column-${justify}`}>
                {content}
            </div>
        )
    }

    getInputColumnJsx = (indexValue) => {
        // console.log("INDEX VALUE AT INPUT COLUMN ", indexValue);
        let helpingHandsList = this.props.dataset2;

        let indexedRow = helpingHandsList[indexValue];
        let peopleNeeded = indexedRow[1];
        // console.log("=========> INPUT QUANTITY " ,inputQuantity);
        return (
            <div className={`piht-text-column-${justify}`}>
                {peopleNeeded}
            </div>
        )
    }

    getButtonColumnJsx = (indexValue) => {
        // console.log("INDEX VALUE AT BUTTON COLUMN JSX ", indexValue);
        
        return (
            <button className="piht-flex-cell-3-alt pic-event-contribute-button piht-modifier-ml1" 
                    onClick={this.handleCountMeInButton.bind(this, indexValue)}>
                Count Me In
            </button>
        )
    }

    getDropDownJsx = (indexValue) => {
        let helpingHandsList = this.props.dataset2;
        /* construct dropdown list */
        let participantList = this.getParticipantList(helpingHandsList, indexValue);

        let ddlist = participantList.map((participant, i) => {
            let name   =  this.truncateLastNameIfTooLong(participant.name);

            return {
                key: i,
                title: `${name}` ,
                selected: false,
                listname: 'contributors'
            }
        })

        return (
            <div className="piht-flex-cell-3-alt">
                <DropDownMenu title="Names" list={ddlist.concat(this.getTextButton(indexValue))} 
                        altHeaderClass="drop-down-header-nb"  
                        altDDListClass="drop-down-list-alt1"
                        config={{displayHeader: false}} toggleSelected={ () => {;} }
                />
            </div>
        )
    }

    //*************************************************************************
    // Row renderers
    //*************************************************************************

    /* Render Header row for contribution table  (processes each header label) */
    getStyledContribHeader = () => {
        let { headerLabels } = this.state;
        let styledHeader = [];
        headerLabels.forEach((headerLabel, idx) => {
            let classname = "piht-header-label-left";
            if (idx === 0) {classname = "pict-header-label-item"};
            if (idx === 1) {classname = "piht-header-label-needed-preview"};
            if (idx === 2) {classname = "pict-header-label-contrib"};
            let headerJsx = this.getHeaderJsx(headerLabel, classname);
            styledHeader.push(headerJsx)
        })
        return styledHeader;
    }


    /* Render rows for help table. Column three intially is the 'Count Me In' button but 
       gets converted to DropDownList when user adds a contribution. This allows them to see the 
       list of names*/
    getStyledHelpTable = (helpingHandsList) => {
        // let { contributions } = this.state;
        // contributionsCopy[indexValue][3] = this.getDropDownJsx();

        let styledRows = [];
        /* add the header to styledRows */
        styledRows.push(this.getStyledContribHeader());
        /* add the table entries to the styledRows ; note add a +1 to create offset for header row */
        // console.log("THIS IS HELPING HANDS LIST");
        // console.log(helpingHandsList);
        helpingHandsList.forEach((row, i) => {
            let itemDescription    = row[0];   /* pull column 0 */
            let neededPeople       = row[1];   /* pull column 1 */
            let theButtonColumn    = row[2];   /* pull column 2 */
         
            let styledRow = []
            styledRow[0] = this.getTextColumnJsx(itemDescription, "left");     /* replaces first column with jsx */
            styledRow[1] = this.getTextColumnJsx(+neededPeople, "center");   /* replaces secnd column with jsx, Note + sign is technique for removing leading zero */
            // if (this.props.mockMode) {
            //     styledRow[2] = this.getDropDownJsx(i);
            // } else {
            // If participant is not in the drop down list for the item and neededPeople > 0, show "Count Me In" button 
            // console.log("PARTICIPANT IN LIST ", this.isParticipantOnList(i)  )
            styledRow[2] = !this.isParticipantOnList(i) && neededPeople > 0  ? this.getButtonColumnJsx(i) :  this.getDropDownJsx(i);
            // }    
            styledRows.push(styledRow)
        })
        return styledRows;
    }

    /* getStyledContribTable Helper function/ */
    isParticipantOnList = (rowIndex) => {
        let helpingHandsList = this.props.dataset2;
        let participantEmail = this.getParticipantEmail();
     
        let contributorsList = helpingHandsList[rowIndex][3];  /* column 3 has the contributors list */
        let indexFound = contributorsList.findIndex(contributor => contributor.email === participantEmail);
        return indexFound === -1 ? false : true;
    }


    //*************************************************************************
    // Utilities / or Help functions
    //*************************************************************************

    /* function to add text button at the end of dropdown list*/
    getTextButton = (indexValue) => {
        /* construct an array with one item to concat to list */
        let textButtonItem = [{
            key: 9999,
            title: <TextButton text="Remove my name" myclassname="text-button-xxsmall" 
                    onClickHandler={this.deleteParticipantFromList.bind(this, indexValue, this.getParticipantEmail())} />
        }]
        return textButtonItem;
    }

    /* This deletes participant form the list a */
    deleteParticipantFromList = (indexValue) => {
        // if (this.props.mockMode === true) {return};

        // let helpingHandslist = this.props.dataset2;

        // /* get contributor list for a given item */
        // let participantList = this.getParticipantList(helpingHandslist, indexValue);

        // /* find participant in the contributor list and obtain amount participant was contributing. */
        // let foundParticipant = participantList.find((participant) => { return participant.email === participantEmail });
       
        // /* If participant not found in contributor list, do nothing. Exit function*/ 
        // if (!foundParticipant) {
        //     this.handleRaiseError("No Action taken: your name was not listed as a participant for this item.");
        //     return;
        // };

        // /* Delete contributor from list */
        // let updatedParticipantList  = participantList.filter((participant) => participant.email !== participantEmail);

        // /* Make copy of help items */
        // let copyOfHelpingHandsList = [...helpingHandslist];
        // /* Replace participant list with list delete participant */
        // copyOfHelpingHandsList[indexValue][3] = updatedParticipantList;
        // /* Add 1 back to the count  */
        // let peopleNeeded = copyOfHelpingHandsList[indexValue][1];
        // copyOfHelpingHandsList[indexValue][1] = peopleNeeded + 1;
        // /* Mark item as "notUpdated" */
        // copyOfHelpingHandsList[indexValue][4] = "notUpdated";
        
        // /* Update contribution list in parent */
        // this.props.handleChangeDataSet2(copyOfHelpingHandsList);

        /* Fire parent call back */
        this.props.handleRemoveContributor(indexValue);
    }

   


    /* The following two methods serve as wrappers that hide the implementation details as 
       as how to get participant name and email. How you get it is based on whether your an authenticated user or 
       participant with a token */

    getParticipantName = () => {
        /* if user is logged in, use the name of the authorized user */
        let participantName = "";
        if (this.props.auth.isAuthenticated) {
            participantName = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname;
        } else if (this.state.eventObj.participantName) {
            participantName = this.state.eventObj.participantName
        } else {
            participantName = this.props.getParentStateValue("participantName");
        }

        return participantName;
    }

    getParticipantEmail = () => {
        /* pull off participantEmail from parent component (PicInvitation) */
        let participantEmail = this.props.getParentStateValue("participantEmail")
        return participantEmail;
    }


    // getParticipantName = () => {
    //     /* if user is logged in, use the name of the authorized user */
    //     let participantName = "";
    //     if (this.props.auth.isAuthenticated) {
    //         participantName = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname;
    //     } else {
    //         participantName = this.state.eventObj.participantName
    //     }
    //     return participantName;
    // }

    // getParticipantEmail = () => {
    //     /* if user is logged in, use the email of the authorized user */
    //     let participantEmail = this.props.auth.user.email || this.state.eventObj.participantEmail || "";

    //     return participantEmail;
    // }

    /* Contributor list   is found as 4th item in table row . Created this help function so that
       in event it moves, I only need to change it one place */
    getParticipantList = (helpingHandsList, rowIndex) => {
        return helpingHandsList[rowIndex][3];
    }
    
    truncateLastNameIfTooLong = (name) => {
        let maxLength = 13;
        let fullname = name.split(' ');

        return (name.length > maxLength) ? fullname[0] : name;
    }

    //*************************************************************************
    // Component render method
    //*************************************************************************
    render() {
        let helpingHandsList = this.props.dataset2;

        let styledHelpTable = this.getStyledHelpTable(helpingHandsList);

        return (
            <div> 
                 <ExpansionPanel onClickHandler={this.handleOnClickForPanel2} text="Helping Hands" open={this.props.open} />
                 {this.props.open  &&  <PicInvitationHelpTable rows={styledHelpTable} /> }  
                 <MessageModal 
                    showModal={this.state.showMessageModal} 
                    message='Please click on "Yes" or "No" to let us know if you will be attending.'
                    cancelHandler={this.handleCancelMessageModal}
                 />  
            </div>
        );
    };

    
};

const mapStateToProps = (state) => {
    return {
        auth:  state.auth
    };
};

export default connect(mapStateToProps)(PicInvitationHelpPanel);
// export default connect(mapStateToProps, mapDispatchToProps)(PicInvitationPanel1);

/*
onChange={this.handleOnChangeQuantity.bind(this, indexValue) }  // Handler called to update the state with whats entered in input field

<DropDownMenu title="Names" list={ddlist.concat(this.getTextButtonItem())} toggleSelected={ () => {;} } 
                                          config={{displayHeader: false}}/>

*/


// WEBPACK FOOTER //
// ./src/components/PicInvitationHelpPanel.js